import React from "react";
import Header from './Header';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TruveyGreenLogo from '../Asset/Images/XSO-White.png';
import AdminService from "../Services/AdminService";

const CreateCompany = () => {
    const token = localStorage.getItem("JWTToken");
    const navigate = useNavigate();
    const UserRoleID = localStorage.getItem("RoleID");
    const [CompanyName, SetCompanyName] = useState('');
    const [State, SetState] = useState();
    const [Country, SetCountry] = useState();
    const [City, SetCity] = useState();
    const [PostalCode, SetPostalCode] = useState();
    const [Address, SetAddress] = useState();
    const [ContactName, SetContactName] = useState();
    const [ContactMail, SetContactMail] = useState();
    const [ContactNumber, SetContactNumber] = useState();
    const [WebsiteURL, SetWebsiteURL] = useState();
    const [ParentCompany, SetParentCompany] = useState();
    const [Subsidiaries, SetSubsidiaries] = useState();
    const [EstablishmentDate, SetEstablishmentDate] = useState();
    const [UserName, SetUserName] = useState();
    const [UserEmail, SetUserEmail] = useState();
    const [UserContactNumber, SetUserContactNumber] = useState();
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [activeTab, setActiveTab] = useState("First");
    useEffect(() => {
        try {
            if (UserRoleID === "3" && token) {
                const GetRoles = async () => {
                    const response = await AdminService.GetRoles(token);
                    if (response) {
                        if (response.STATUS === "SUCCESS") {
                            setRoles(response.RESPONSE);
                            console.log(response.RESPONSE);
                        }
                    }
                }
                GetRoles();
            } else {
                navigate("/Login");
            }
        } catch (error) {
            console.error(error)
        }
    }, [token, UserRoleID, navigate]);

    const handleNextClick = () => {
        const trimmedCompanyName = CompanyName.trim();
        if (trimmedCompanyName === '') {
            alert('Company Name is required.');
        } else {
            setActiveTab('Second');
        }
    };
    const handleroleChange = (event) => {
        const selectedRoleId = event.target.value;
        setSelectedRole(selectedRoleId);
    };
    const validate = () => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobilePattern = /^[0-9]{10}$/; // Assumes a 10-digit number without country code
    
        if (!CompanyName || CompanyName.trim() === "") {
            alert("Company Name is required");
            return false;
        }
        if (!UserName || UserName.trim() === "") {
            alert("User Name is required");
            return false;
        }
        if (!UserEmail || UserEmail.trim() === "") {
            alert("User Email is required");
            return false;
        }
        if (!emailPattern.test(UserEmail)) {
            alert("Please enter a valid email address");
            return false;
        }
        if (!UserContactNumber || UserContactNumber.trim() === "") {
            alert("User Contact Number is required");
            return false;
        }
        if (!mobilePattern.test(UserContactNumber)) {
            alert("Please enter a valid 10-digit mobile number");
            return false;
        }
        if (!selectedRole || selectedRole.trim() === "") {
            alert("Selected Role is required");
            return false;
        }
    
        return true; 
    };
    
    const SaveCompanyData = async () => {
        if (validate()) {
            try {
                const companyData = {
                    CompanyName,
                    State,
                    Country,
                    City,
                    PostalCode,
                    Address,
                    ContactName,
                    ContactMail,
                    ContactNumber,
                    WebsiteURL,
                    ParentCompany,
                    Subsidiaries,
                    EstablishmentDate
                };
                const AdminData = {
                    AdminName:UserName,
                    AdminEmail:UserEmail,
                    AdminMobileNo:UserContactNumber,
                    AdminRole:selectedRole
                };
                const SurveyData={token}
    
                const response = await AdminService.CreateCompany(SurveyData, AdminData, companyData);
                if (response) {
                    alert(response.MESSAGE);
                    navigate('/AdminService');
                }
            } catch (error) {
                console.error("Error creating company:", error);
                alert("Failed to create company. Please try again.");
            }
        }
    };
    
    const readerTab = () => {
        switch (activeTab) {
            case 'First': return (<>
                <div className="container my-5">
                    <div className="row nav-tabs border-0">
                        <div className="col-7 shadow p-4 mx-auto z-index1031 bg-white">
                            <div className="p-4">
                                <h5 className="TruveyColor fw-bold text-center">Add new Company</h5>
                            </div>
                            <div className="mb-5">
                                <div className="mb-4">
                                    <label htmlFor="CompanyName" className="nav-link">Company Name <sup className="text-danger">*</sup> </label>
                                    <input type="text" id="CompanyName" className="Sanket-Control fs-14 p-2 mt-2" value={CompanyName} onChange={(e) => SetCompanyName(e.target.value)} />
                                </div>

                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 fw-bold btn"><Link to={"/AdminPanel"} className="Truveytext">Cancel</Link></button>
                                <button className="Gold px-4  border-0 br-5" onClick={handleNextClick}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>);
            case 'Second': return (<>
                <div className="row  container mx-auto Companymodal">
                    <div className="col-6 shadow p-4 mx-auto z-index1031 TruveyBG d-flex justify-content-center align-items-center">
                        <div className="col-md-7 col-lg-6 col-xl-5 h-100 d-flex align-items-center">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                                <p className="text-white mt-3 fw-0">Conduct better surveys, get insightful reports.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 shadow mx-auto p-3 z-index1031 bg-white">
                        <div className="text-end">
                            <button className="border-0 btn" onClick={() => setActiveTab('Third')}>Skip</button>
                        </div>
                        <div className="h-100 d-flex flex-column justify-content-evenly p-4">
                            <div>
                                <div className="mb-4">
                                    <label htmlFor="Contact Name" className="nav-link">Contact Name</label>
                                    <input type="text" id="Contact_Name" value={ContactName} onChange={(e) => { SetContactName(e.target.value) }} className="Sanket-Control fs-14 p-2 mt-2" />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="Email" className="nav-link">Contact Email</label>
                                    <input type="Email" id="Email" value={ContactMail} className="Sanket-Control fs-14 p-2 mt-2" onChange={(e) => { SetContactMail(e.target.value) }} />
                                </div>
                                <div>
                                    <label htmlFor="number" className="nav-link">Contact Number</label>
                                    <input type="tel" id="number" maxLength={10} value={ContactNumber} onChange={(e) => { SetContactNumber(e.target.value) }} className="Sanket-Control fs-14 p-2 mt-2" />
                                </div>
                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 btn" onClick={() => setActiveTab('First')}>Back</button>
                                <button className="Gold px-4  border-0 br-5" onClick={() => setActiveTab('Third')}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>

            </>);
            case 'Third': return (<>
                <div className="row  container mx-auto Companymodal">
                    <div className="col-6 shadow p-4 mx-auto z-index1031 TruveyBG d-flex justify-content-center align-items-center">
                        <div className="col-md-7 col-lg-6 col-xl-5 h-100 d-flex align-items-center">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                                <p className="text-white mt-3 fw-0">Conduct better surveys, get insightful reports.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 shadow p-3 mx-auto z-index1031 bg-white">
                        <div className="text-end">
                            <button className="border-0 btn" onClick={() => setActiveTab('Fourth')}>Skip</button>
                        </div>
                        <div className="h-100 d-flex flex-column justify-content-evenly p-4">
                            <div>
                                <div className="mb-4">
                                    <label htmlFor="Parent_Company" className="nav-link">Parent Company</label>
                                    <input type="text" id="Parent_Company" className="Sanket-Control fs-14 p-2 mt-2" value={ParentCompany} onChange={(e) => { SetParentCompany(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="Subsidiaries" className="nav-link">Subsidiaries</label>
                                    <input type="text" id="Subsidiaries" className="Sanket-Control fs-14 p-2 mt-2" value={Subsidiaries} onChange={(e) => { SetSubsidiaries(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="Establishment_Date" className="nav-link">Establishment Date</label>
                                    <input type="date" id="Establishment_Date" maxLength={10} className="Sanket-Control fs-14 p-2 mt-2" value={EstablishmentDate} onChange={(e) => { SetEstablishmentDate(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="WebsiteURL" className="nav-link">WebsiteURL</label>
                                    <input type="text" id="WebsiteURL" className="Sanket-Control fs-14 p-2 mt-2" value={WebsiteURL} onChange={(e) => { SetWebsiteURL(e.target.value) }} />
                                </div>
                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 btn" onClick={() => setActiveTab('Second')}>Back</button>
                                <button className="Gold px-4  border-0 br-5" onClick={() => setActiveTab('Fourth')}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>

            </>);
            case 'Fourth': return (<>
                <div className="row  container mx-auto Companymodal">
                    <div className="col-6 shadow p-4 mx-auto z-index1031 TruveyBG d-flex justify-content-center align-items-center">
                        <div className="col-md-7 col-lg-6 col-xl-5 h-100 d-flex align-items-center">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                                <p className="text-white mt-3 fw-0">Conduct better surveys, get insightful reports.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 shadow p-3 mx-auto z-index1031 bg-white">
                        <div className="text-end">
                            <button className="border-0 btn" onClick={() => setActiveTab('Fifth')}>Skip</button>
                        </div>
                        <div className="h-100 d-flex flex-column justify-content-evenly p-4">
                            <div>
                                <div className="mb-4">
                                    <label htmlFor="Postal_Code" className="nav-link">Postal Code</label>
                                    <input type="text" id="Postal_Code" className="Sanket-Control fs-14 p-2 mt-2" value={PostalCode} onChange={(e) => { SetPostalCode(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="City" className="nav-link">City</label>
                                    <input type="text" id="City" className="Sanket-Control fs-14 p-2 mt-2" value={City} onChange={(e) => { SetCity(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="Country" className="nav-link">Country</label>
                                    <input type="text" id="Country" className="Sanket-Control fs-14 p-2 mt-2" value={Country} onChange={(e) => { SetCountry(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="State" className="nav-link">State</label>
                                    <input type="text" id="State" className="Sanket-Control fs-14 p-2 mt-2" value={State} onChange={(e) => { SetState(e.target.value) }} />
                                </div>
                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 btn" onClick={() => setActiveTab('Third')}>Back</button>
                                <button className="Gold px-4  border-0 br-5" onClick={() => setActiveTab('Fifth')}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
            case 'Fifth': return (<>
                <div className="row container mx-auto Companymodal">
                    <div className="col-6 shadow p-4 mx-auto z-index1031 TruveyBG d-flex justify-content-center align-items-center">
                        <div className="col-md-7 col-lg-6 col-xl-5 h-100 d-flex align-items-center">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                                <p className="text-white mt-3 fw-0">Conduct better surveys, get insightful reports.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 shadow p-3 mx-auto z-index1031 bg-white">
                        <div className="text-end">
                            <button className="border-0 btn" onClick={() => setActiveTab('Sixth')}>Skip</button>
                        </div>
                        <div className="h-100 d-flex flex-column justify-content-evenly p-4">
                            <div>
                                <div className="mb-4">
                                    <label htmlFor="Address" className="nav-link">Address</label>
                                    <textarea id="Address" className="Sanket-Control fs-14 p-2 mt-2" cols="5" rows="7" value={Address} onChange={(e) => { SetAddress(e.target.value) }} />
                                </div>
                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 btn" onClick={() => setActiveTab('Fourth')}>Back</button>
                                <button className="Gold px-4  border-0 br-5" onClick={() => setActiveTab('Sixth')}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
            case 'Sixth': return (<>
                <div className="row  container mx-auto Companymodal">
                    <div className="col-6 shadow p-4 mx-auto z-index1031 TruveyBG d-flex justify-content-center align-items-center">
                        <div className="col-md-7 col-lg-6 col-xl-5 h-100 d-flex align-items-center">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                                <p className="text-white mt-3 fw-0">Conduct better surveys, get insightful reports.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 shadow p-3 mx-auto z-index1031 bg-white">
                        <div className="h-100 d-flex flex-column justify-content-evenly p-4">
                            <div>
                                <div className="mb-4">
                                    <label htmlFor="User_Name" className="nav-link">User Name <sup className="text-danger">*</sup> </label>
                                    <input type="text" id="User_Name" className="Sanket-Control fs-14 p-2 mt-2" value={UserName} onChange={(e) => { SetUserName(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="User_Email" className="nav-link">User Email <sup className="text-danger">*</sup></label>
                                    <input type="email" id="User_Email" className="Sanket-Control fs-14 p-2 mt-2" value={UserEmail} onChange={(e) => { SetUserEmail(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="User_MobileNumber" className="nav-link">User Mobile Number <sup className="text-danger">*</sup></label>
                                    <input type="text" id="User_MobileNumber" className="Sanket-Control fs-14 p-2 mt-2" value={UserContactNumber} onChange={(e) => { SetUserContactNumber(e.target.value) }} />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="Email" className="nav-link">Role <sup className="text-danger">*</sup></label>
                                    <select className="Sanket-Control  nav-link mt-2 fs-14 p-2" value={selectedRole} onChange={handleroleChange}>
                                        <option value="">Select a role</option>
                                        {
                                            roles.map((data) =>
                                            (
                                                <>
                                                    <option key={data.RoleID} value={data.RoleID}>{data.RoleName}</option>
                                                </>
                                            )
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="text-end pt-3">
                                <button className="me-3 btn" onClick={() => setActiveTab('Fifth')}>Back</button>
                                <button className="Gold px-4  border-0 br-5" onClick={SaveCompanyData}>Finish</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>);
            default: return (<>
                <p>Error Please Rage The Ticket</p>
            </>)
        }
    }
    return (<>
        <Header />
        <div className="min-hight85vh">
            <div className="d-block overlay"></div>
            <div className="bg-grey py-3">
                <div className="container">
                    <Link className="fs-18 BackBtn text-dark" to={'/AdminPanel'}>
                        Admin Panel
                    </Link> <span className="fs-18">/ Create new Company</span>
                </div>
            </div>

            {readerTab()}
        </div>

    </>)
}
export default CreateCompany;